import { render, staticRenderFns } from "./PopularDecks.vue?vue&type=template&id=2ad77a32&scoped=true"
import script from "./PopularDecks.vue?vue&type=script&lang=js"
export * from "./PopularDecks.vue?vue&type=script&lang=js"
import style0 from "./PopularDecks.vue?vue&type=style&index=0&id=2ad77a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad77a32",
  null
  
)

export default component.exports